<template>
  <div :class="{ fullWidthLayout: $route.meta.fullWidthLayout }">
    <logged-in-nav-bar v-if="userLoggedIn"></logged-in-nav-bar>

    <custom-side-bar v-if="userLoggedIn"></custom-side-bar>

    <div
      class="main-content"
      @click="$sidebar.displaySidebar(false)"
      :class="{
        loggedin: userLoggedIn
      }"
    >
      <fade-transition :duration="200" origin="center top" mode="out-in">
        <router-view></router-view>
      </fade-transition>

      <custom-footer></custom-footer>
    </div>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import CustomSideBar from "@/components/Custom/CustomSideBar";
import CustomFooter from "@/components/Custom/CustomFooter";
import LoggedInNavBar from "@/components/Custom/LoggedInNavBar";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    FadeTransition,
    CustomSideBar,
    CustomFooter,
    LoggedInNavBar
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page"
    };
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
    ...mapGetters("user", ["userLoggedIn"])
  },
  methods: {
    toggleSidebar() {
      console.log("Toggling sidebar!");
      console.log(this.$sidebar.showSidebar);
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    preventHide(ev) {
      console.log("PREVENTING HIDE!");
      console.log(ev);
      if (window.innerWidth <= 576) {
        ev.preventDefault();
      }
    },
    closeDropdown() {
      // Close the menu and (by passing true) return focus to the toggle button
      this.$refs.featuredropdown.hide(true);
    },
    toggleNavbar() {
      console.log("Toggling navbar...");
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      console.log("Closing menu...");
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-gradient-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-gradient-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    }
  },
  beforeDestroy() {
    this.removeBackgroundColor();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      console.log("Closing menu due to route update..");
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateBackground();
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
<style lang="scss">
.navbar-horizontal .navbar-nav .nav-link .nav-link-inner--text {
  margin-left: 0;
}

$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

/*
.fullWidthLayout .main-content {
  padding-top: 7rem !important;
}

.fullWidthLayout .main-content.loggedin {
  padding-top: 0 !important;
}
 */

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}

@media (min-width: 992px) {
  .navbar-horizontal .navbar-nav:not(.navbar-nav-hover) .dropdown-menu.show {
    width: 400px;
  }
}
.navbar-horizontal .navbar-brand img {
  height: 70px;
}

@media (min-width: 576px) {
  .navbar-home .navbar-collapse {
    background-color: transparent;
  }
  .navbar-horizontal.navbar-transparent .navbar-nav .nav-link {
    color: rgba(255, 255, 255, 0.95);
  }
}

.menu-sidenav-toggler {
  display: block;
}

@media (min-width: 1200px) {
  .menu-sidenav-toggler {
    display: none;
  }
}
</style>
